import React from 'react';
import Field from '../../common/Field/Field';
import RequiredDropDown from '../../common/RequiredDropDown/RequiredDropDown';

export const JobPostingDropdown = ({
  value,
  options,
  isValid,
  errorText,
  jpKey,
  label,
  dirty,
  description,
  didError,
  required,
  defaultHeader = 'Please select a value',
  updateJobPostingAttr
}) => {

  return (
    <Field
      label={label}
      dirty={dirty}
      description={description}
      showError={didError}
      errorText={errorText}
      required={required}
    >
      <RequiredDropDown
        header={value || defaultHeader}
        options={options}
        isValid={isValid}
        errorText={errorText}
        testId={`job-posting-editor-${jpKey}`}
        handleChange={updateJobPostingAttr}
      />
    </Field>
  );
};